var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8399 3.62837L65.3716 0.160034L0.159912 65.3717L3.62825 68.84L8.53397 63.9343H59.0285C60.329 63.9324 61.5756 63.4149 62.4952 62.4953C63.4148 61.5757 63.9323 60.3291 63.9342 59.0286V8.53409L68.8399 3.62837ZM59.0285 59.0286H13.4397L32.5548 39.9135L38.3901 45.7488C39.3101 46.6685 40.5577 47.1852 41.8585 47.1852C43.1593 47.1852 44.4069 46.6685 45.3268 45.7488L49.2171 41.8586L59.0285 51.6627V59.0286ZM59.0285 44.7235L52.6854 38.3805C51.7654 37.4608 50.5179 36.9441 49.2171 36.9441C47.9162 36.9441 46.6687 37.4608 45.7487 38.3805L41.8585 42.2707L36.028 36.4402L59.0285 13.4398V44.7235ZM9.97134 49.2172V41.8586L22.2356 29.6017L25.6034 32.9719L29.0766 29.4987L25.704 26.126C24.784 25.2063 23.5364 24.6897 22.2356 24.6897C20.9348 24.6897 19.6872 25.2063 18.7673 26.126L9.97134 34.9219V9.97146H49.2171V5.06575H9.97134C8.67066 5.06705 7.42363 5.58432 6.50391 6.50403C5.58419 7.42375 5.06693 8.67079 5.06563 9.97146V49.2172H9.97134Z",
    fill: "grey"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.e8afadce33f4b1bdd3a1a966aa9ed0cc.svg";
export { ForwardRef as ReactComponent };